import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ShowInvoiceResponseV4Schema } from "../schema/ShowInvoiceResponseV4";

// Tipe untuk argumen hook
interface UseShowInvoiceV4Props {
    invoiceNumber: string;
}

export const useShowInvoiceV4 = ({ invoiceNumber }: UseShowInvoiceV4Props) => {
    return useQuery({
        // queryKey dibuat unik dengan menyertakan nomor invoice
        queryKey: ['invoice', invoiceNumber],

        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/invoice/${invoiceNumber}`);

                // Validasi respons API dengan skema Zod
                const validationResult = ShowInvoiceResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("API Response Validation Failed (useShowInvoiceV4):", validationResult.error.errors);
                    throw new Error("Invalid invoice data format received from the server.");
                }

                return validationResult.data;

            } catch (error) {
                console.error(`Failed to fetch invoice with number ${invoiceNumber}`, error);
                throw error;
            }
        },
        // Query hanya akan berjalan jika invoiceNumber ada
        enabled: !!invoiceNumber,
        retry: 1, // Hanya coba lagi 1 kali untuk permintaan 'show'
        refetchOnWindowFocus: false,
    });
};